module.exports = __webpack_public_path__ + "static/logo-8846efeebfb07df3ff0192c5a011d9a2.svg";